import { InProductTrialsAppBaseDataProvider } from './InProductTrialsAppBaseDataProvider';
import { AvailableInProductTrialsDetails } from '../types/AvailableInProductTrialsDetails';
import { AvailableProductTrialType } from '../../types/AvailableProductTrialType';
import {
  FetchProductBuyInitialDataFunction,
  FetchProductBuyPriceFunction,
  FetchProductBuyUrlFunction,
} from '../../types/ProductLandingPageBuyConfig';

export class InProductTrialsAppGzDataProvider extends InProductTrialsAppBaseDataProvider {
  public async getAvailableInProductTrials(): Promise<AvailableInProductTrialsDetails> {
    const record = await this.dependencies.api.clients.InProductTrials.ReadAvailableInProductTrials().toPromise();

    if (!record) {
      throw new Error('No data for available in product trials.');
    }

    return record;
  }

  public async startInProductTrial(
    type: AvailableProductTrialType
  ): Promise<{ success: boolean; errorMessage?: string }> {
    return await this.dependencies.api.clients.InProductTrials.StartInProductTrial(type).toPromise();
  }

  public async requestInProductTrial(
    type: AvailableProductTrialType,
    remarks?: string,
  ): Promise<{ success: boolean; errorMessage?: string }> {
    return await this.dependencies.api.clients.InProductTrials.RequestInProductTrial(type, remarks).toPromise();
  }

  public async cancelInProductTrial(
    type: AvailableProductTrialType
  ): Promise<{ success: boolean; errorMessage?: string }> {
    return await this.dependencies.api.clients.InProductTrials.CancelInProductTrial(type).toPromise();
  }

  public async fetchProductBuyInitialData(
    productType: AvailableProductTrialType
  ): ReturnType<FetchProductBuyInitialDataFunction> {
    return await this.dependencies.api.clients.InProductTrials.FetchProductBuyInitialData(productType).toPromise();
  }

  public async fetchProductBuyPrice(
    productType: AvailableProductTrialType,
    seatsCount: number,
    validityYears: number
  ): ReturnType<FetchProductBuyPriceFunction> {
    return await this.dependencies.api.clients.InProductTrials.FetchProductBuyPrice(
      productType,
      seatsCount,
      validityYears
    ).toPromise();
  }

  public async fetchProductBuyUrl(
    productType: AvailableProductTrialType,
    seatsCount: number,
    validityYears: number
  ): ReturnType<FetchProductBuyUrlFunction> {
    return await this.dependencies.api.clients.InProductTrials.FetchProductBuyUrl(
      productType,
      seatsCount,
      validityYears
    ).toPromise();
  }
}
